//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// @TODO: lease_expire_date no longer exists - it is `termination_date`. But here we want `lease_expiration_date`
// In this code it doesn't actually matter, but change & test to make it less confusing
export default {
    data: function data() {
        return {
            loading: false,
            readonly: true,
            unitSelected: '',
            person: {},
            contact_preferences: ['SMS', 'Email', 'Phone'],
            formData: {},
            applicants: [],
            policyTypes: ['Plan A', 'Plan B', 'Master Policy', 'HO4', 'None', 'Other'],
            rentalPolicyStatus: ['Active', 'Expired', 'Canceled'],
            moveInValidations: [{ model: 'person.personId', rules: 'required | integer | min:1' }, { model: 'person.applicantId', rules: 'required | integer | min:1' }, { model: 'person.move_in_date', rules: 'required | before_or_equal:person.lease_start_date' }, { model: 'person.first_name', rules: 'required' }, { model: 'person.last_name', rules: 'required' }, { model: 'person.email', rules: 'required' }, { model: 'person.phone', rules: 'required' }, { model: 'person.contactPreference', rules: 'required' }, { model: 'person.hasEnergyze', rules: 'required' }, { model: 'person.unitId', rules: 'required | integer | min:1' }, { model: 'person.propertyId', rules: 'required | integer | min:1' }, { model: 'person.actual_rent_amount', rules: 'required | integer | min:1' }, { model: 'person.prorated_rent', rules: 'required | integer | min:1' }, { model: 'person.lease_start_date', rules: 'required | before_or_equal:person.lease_expire_date' }, { model: 'person.lease_expire_date', rules: 'required' }]
        };
    },
    created: function created() {
        Event.$on('convert-applicant', this.addResidentMount);
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('convert-applicant');
    },


    methods: {
        addResidentMount: function addResidentMount(item) {
            var $el = this;
            Object.assign(this.$data, this.$options.data());
            $el.$children[0].$data.showModal = true;
            this.person = Object.assign({}, item);

            var total = 0;
            if (item.unit_amenities.length) {
                item.unit_amenities.forEach(function (amenity) {
                    total += parseInt(amenity.value);
                });
            }
            this.person.actual_rent_amount = parseInt(item.actual_rent_amount) + total;
            this.cal_prorated_rent();
            this.person.actual_rent_amount = 0;
            this.person.hasEnergyze = 'No';
            this.person.start_date = item.move_in_date;
            this.person.end_date = item.lease_expire_date;
        },
        addResident: function addResident() {
            var _this = this;

            this.$initValidator();
            setTimeout(function () {
                _this.validator.setRules(_this.moveInValidations).validate();
                if (_this.validator.fails()) {
                    return;
                }
                var $el = _this;
                $el.loading = true;
                _this.person.moveInDate = moment(_this.person.move_in_date).format('YYYY-MM-DD');
                _this.person.firstName = _this.person.first_name;
                _this.person.lastName = _this.person.last_name;
                _this.person.hasEnergyze = _this.person.hasEnergyze;
                _this.person.residentDepositAmount = _this.person.security_deposit;
                _this.person.actualRentAmount = _this.person.actual_rent_amount;
                _this.person.proratedRent = _this.person.prorated_rent;
                _this.person.leaseStartDate = moment(_this.person.lease_start_date).format('YYYY-MM-DD');
                _this.person.leaseExpirationDate = moment(_this.person.lease_expire_date).format('YYYY-MM-DD');
                axios.post('/prototype/person/residents/move-ins', _this.person).then(function (response) {
                    if (response.data) {
                        $el.loading = false;
                        Event.$emit('resident-list-dashboard-updated');
                        Event.$emit('close-full-modal');
                        Event.$emit('updated-applicants-list');
                        Event.$emit('updated-pending-applicants-list');
                        Object.assign(_this.$data, _this.$options.data());
                    }
                });
            });
        },
        cancelGuestCard: function cancelGuestCard() {
            Event.$emit('close-full-modal');
        },
        leaseStartDateChanged: function leaseStartDateChanged() {
            this.person.lease_expire_date = this.person.lease_expire_date ? moment(this.person.lease_start_date).subtract(1, 'days').add(1, 'years').format("MM/DD/YYYY") : '';
            this.cal_prorated_rent();
        },
        cal_prorated_rent: function cal_prorated_rent() {
            var rent_amount = this.person.actual_rent_amount,
                lease_start_date = this.person.lease_start_date;

            if (!rent_amount) return 0;
            if (!lease_start_date) return rent_amount;

            lease_start_date = moment(lease_start_date, 'MM/DD/YYYY');

            var endOfMonth = lease_start_date.clone();
            endOfMonth = moment(endOfMonth.add(1, 'months').date(1).format('YYYY-MM-DD'));

            var days = endOfMonth.diff(lease_start_date, 'days');
            var daysInMonth = lease_start_date.daysInMonth();
            this.person.prorated_rent = (rent_amount / daysInMonth * days).toFixed(2);
        }
    }

};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/AddResident.vue
// module id = 6yih
// module chunks = 0 1